
// middleware/auth.js
import {useAuthStore} from "~/stores/auth/index.js";

export default defineNuxtRouteMiddleware((to) => {
    const authStore = useAuthStore()

    // Si l'utilisateur n'est pas authentifié, rediriger vers login
    if (!authStore.isLoggedIn) {
        return navigateTo('/auth/login')
    }
})